import IndexTable from 'shared/components/navigation/index_table/IndexTable';
import IndexTableRow from 'shared/components/navigation/index_table/IndexTableRow';

IndexTable.Row = IndexTableRow;

export {
  IndexTable
};
